<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          :custom-css="customCssUrl" :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled" ref="registrationSection">
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
          :show-confirmation="show_confirmation" :custom-css="customCssUrl" :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered" :language="$t('Language')"></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'" ref="thanksSection" class="text-center py-5">
        <h1 class="mb-4 fw-bold">{{ $t('IPEwidget.ThanksTitle') }}</h1>
        <p v-html="$t('IPEwidget.ThanksDesc')" class="mb-0 mx-auto">
        </p>
      </div>
      <div id="upload-wrapper" v-if="upload_enabled" ref="uploadSection">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="hide-dlr">
            <h2 class="text-center my-4">{{ $t('IPEwidget.UploadReceiptTitle') }}</h2>
          </div>
          <div class="show-dlr" style="display: none;">
            <h2 class="text-center my-4">{{ $t('IPEwidget.DLRTitle') }}</h2>
          </div>
          <div v-html="$t('IPEwidget.ImageUploadDesc1')" class="mt-4 mb-0 hide-dlr"></div>
          <div class="mt-4 mb-0 hide-dlr">
            <p><small v-html="$t('Home.ParticipatingProductLink')" @click="handleLinkClick"></small></p>
            <p><small v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small></p>
          </div>
          <snipp-upload :campaign-id="campaignId" include-upload-button="true"
            @snipp-upload-result="handleSnippUploadResult" @snipp-widget-event="handleSnippWidgetEvent"
            :custom-css="customCssUrl" :language="$t('Language')"></snipp-upload>

        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload :campaign-id="campaignId" include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult" :custom-css="customCssUrl"
            :language="$t('Language')"></snipp-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      uploadLimitReached: false,
      showDlr: false,
      customCssUrl: '/assets/css/custom_overrides.css',
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
      this.$nextTick(() => {
        this.$refs.registrationSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
      this.$nextTick(() => {
        this.$refs.thanksSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleEnterAgain() {
      this.upload_enabled = 'upload';
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippWidgetEvent(e) {
      // check inside event
      if (e && e.detail && e.detail.length) {
        let message = e.detail[0];
        this.uploadLimitReached = true;
        const elements2 = document.querySelectorAll('.show-dlr');
        if (message.upload_limit_reached) {
          // ... TODO: some cool reactive handling to update your UI here ...
          this.showDlr = true;
          const elements = document.querySelectorAll('.hide-dlr');
          elements.forEach(el => {
            el.style.display = 'none';
          });

          elements2.forEach(el => {
            el.style.display = 'block';
          });
        }
        else {
          elements2.forEach(el => {
            el.style.display = 'none';
          });
        }
      }

    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1); // e.g. 'FAQ' from '/FAQ'

          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              // Fallback if route name doesn't exist
              this.$router.push(href);
            });
          }
        }
      }
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },

};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto
}

@media screen and (max-width: 575px) {

  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto
  }
}
</style>
